/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import { SvgIcon, Button } from '../'

export const Input = (props) => {
  let id = props.id || `text-input-id-${Math.floor(Math.random() * 1000)}`
  let inputClearIcon = `${props.clearIcon ? "slds-input-has-icon slds-input-has-icon_right" : ''}`
  let buttonClearIcon = `${props.clearIcon ? "slds-input__icon slds-input__icon_right slds-button" : ''}`

  return (
    <div
      className={`slds-form-element${props.hasError ? " slds-has-error" : ''} ${props.className ? props.className : ''}`}
      style={{ lineHeight: props.required ? '0.3rem' : 'inherit' }}>
      {props.label &&
        <label
          className="slds-form-element__label"
          htmlFor={id}>
          {props.label}
        </label>
      }
      <div className={`slds-form-element__control slds-grid ${inputClearIcon}`}>
        <input
          id={id}
          type={props.type || "text"}
          title={props.title}
          className={`slds-input${props.bare ? " slds-input_bare" : ''}${props.currencyInput ? ' currency-input_input' : ''}${props.rightAlignText ? ' slds-text-align_right' : ''}`}
          placeholder={props.placeholder}
          value={props.value}
          disabled={props.disabled}
          onChange={props.onChange}
          onKeyPress={props.onKeyPress}
          onBlur={props.onBlur}
          onClick={props.onClick}
          autoFocus={props.autoFocus}
          style={{ maxWidth: props.maxWidth || 'none' }}
          step={props.stepSize}
          min={props.minValue}
          lang='en_gb'
        />
        {props.clearIcon && props.value && props.value.length > 0 &&
          <Button type='reset' className={`slds-col_bump-left ${buttonClearIcon}`} onClick={props.onClear}>
            <SvgIcon
              variant="utility"
              symbol="clear"
              buttonIcon={true}
              className="slds-icon-text-light"
              style={{ right: 0 }}
            />
          </Button>
        }
      </div>
    </div>
  )
}

Input.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string, // accepts valid <input> types (see https://www.w3schools.com/tags/tag_input.asp)
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  clearIcon: PropTypes.bool,
  onClear: PropTypes.func,
  hasError: PropTypes.bool,
  onBlur: PropTypes.func,
  bare: PropTypes.bool,
  disabled: PropTypes.bool,
  stepSize: PropTypes.string, // see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/number#Controlling_step_size
  minValue: PropTypes.string,
  maxWidth: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  autoFocus: PropTypes.bool,
  title: PropTypes.string,
  currencyInput: PropTypes.bool,
  rightAlignText: PropTypes.bool,
  className: PropTypes.string
}

Input.defaultProps = {
  maxWidth: 'inherit',
  rightAlignText: false
}



// WEBPACK FOOTER //
// ./src/components/input/index.js